<template>
  <div>
    <v-dialog v-model="bankDialog" max-width="400">
      <v-card>
        <v-card-title>{{ $t('payment.add_bank_account') }}</v-card-title>
        <v-card-text class="py-5">
          <span>{{ $t('payment.bank') }}</span>
          <v-autocomplete
            :label="$t('payment.bank')"
            item-text="name"
            item-value="code"
            :items="banks"
            solo
            background-color="grey lighten-4"
            flat
            v-model="form.bankCode"
            ><template v-slot:item="{ item }">
              <v-list-item-avatar>
                <img
                  :src="require(`../assets/images/bank/${item.code}.jpg`)"
                  max-width="35"
                  max-height="35"
                />
              </v-list-item-avatar>
              {{ item.name }} {{ item.name_en }}
            </template></v-autocomplete
          >
          <span>{{ $t('payment.account_number_label') }}</span>
          <v-text-field
            :label="$t('payment.account_number_label')"
            solo
            background-color="grey lighten-4"
            flat
            v-model="form.accountNumber"
          ></v-text-field>
          <span>{{ $t('payment.account_name') }}</span>
          <v-text-field
            :label="$t('payment.account_name')"
            solo
            background-color="grey lighten-4"
            flat
            v-model="form.accountName"
          ></v-text-field>
          <span>{{ $t('payment.branch') }}</span>
          <v-text-field
            :label="$t('payment.branch')"
            solo
            background-color="grey lighten-4"
            flat
            v-model="form.accountBranch"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="bankDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="onSave"
            :disabled="
              form.bankCode == '' ||
              form.accountName == '' ||
              form.accountNumber == '' ||
              form.accountBranch == ''
            "
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PageName",
  computed: {
    bankDialog: {
      get() {
        this.form = {
          bankCode: "",
          accountNumber: "",
          accountName: "",
          accountBranch: "",
        };
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {},
  data() {
    return {
      banks: [],
      form: {
        bankCode: "",
        accountNumber: "",
        accountName: "",
        accountBranch: "",
      },
    };
  },
  props: {
    value: Boolean,
  },
  created() {
    this.banks = [
        { code: "000", name: this.$t('bank.000'), name_en: "PromptPay" },
        { code: "002", name: this.$t('bank.002'), name_en: "Bangkok Bank" },
        { code: "004", name: this.$t('bank.004'), name_en: "Kasikorn Bank" },
        { code: "006", name: this.$t('bank.006'), name_en: "Krung Thai Bank" },
        { code: "011", name: this.$t('bank.011'), name_en: "Thai Military Bank" },
        {
          code: "014",
          name: this.$t('bank.014'),
          name_en: "Siam Commercial Bank",
        },
        {
          code: "025",
          name: this.$t('bank.025'),
          name_en: "Bank of Ayudhya",
        },
        {
          code: "030",
          name: this.$t('bank.030'),
          name_en: "Government Savings Bank",
        },
        {
          code: "033",
          name: this.$t('bank.033'),
          name_en: "Government Housing Bank",
        },
        {
          code: "034",
          name: this.$t('bank.034'),
          name_en: "Bank for Agriculture and Agricultural Cooperatives",
        },
        { code: "065", name: this.$t('bank.065'), name_en: "Thanachart Bank" },
        { code: "069", name: this.$t('bank.069'), name_en: "Kiatnakin Bank" },
        { code: "022", name: this.$t('bank.022'), name_en: "CIMB" },
        {
          code: "066",
          name: this.$t('bank.066'),
          name_en: "Islamic Bank (Thailand)",
        },
        { code: "067", name: this.$t('bank.067'), name_en: "TISCO Bank" },
        { code: "024", name: this.$t('bank.024'), name_en: "UOB" },
        {
          code: "073",
          name: this.$t('bank.073'),
          name_en: "Land and House Bank",
        },
        {
          code: "070",
          name: this.$t('bank.070'),
          name_en: "ICBC (Thailand)",
        },
    ];
  },
  methods: {
    onSave() {
      this.$emit("onSave", this.form);
      this.bankDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
